import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Header from '../component/Header'
import Footer from '../component/Footer'
import HomeRealEstateAgentForm from '../component/HomeRealEstateAgentForm'
import ExploreResultLocations from '../component/ExploreResultLocations'
import RecommendedYou from '../component/RecommendedYou'
import ProductView from '../component/ProductView'
import ProductDetails from '../component/ProductDetails'
import { useProperty } from "../hooks/useProperty";

function BuyDetails() {
  const { property, loading } = useProperty();


  if (loading) return <div>Loading...</div>;
  if (!property) return <div>Property not found</div>;
  return (
    <>
      <div className='main product-details'>
        <Header />
        <ProductView property={property} />
        <ProductDetails property={property} />
        <HomeRealEstateAgentForm property={property} />
        <RecommendedYou />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  )
}
export default BuyDetails


